import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'en': {
        alquilar : 'Rent',
        alquilar_ahora: 'Rent now',
        flota : 'Fleet',
        menu_promociones :'promotions',
        menu_beneficios : 'Benefits',
        contacto : 'Contact',
        te_ayudamos : 'we help you?',
        amplia_gama : 'Wide range and availability of vehicles',
        amplia_gama_body : 'You will always find the vehicle that best suits your needs. We have a large and varied fleet, with models of all sizes and features.',
        reservar : 'Reserve',
        mejor_experiencia : 'The Best Insured Experience',
        personal_capacitado : 'Trained staff',
        personal_capacitado_body : 'We have the best team, fully trained to provide you with the best service.',
        servicio_excelencia : 'Service of excellence',
        servicio_excelencia_body : 'We accommodate your needs to give you the best experience in car rental at the best price on the market.',
        atencion_cliente : 'Customer care',
        atencion_cliente_1 : 'Contact us from Monday to Sunday from 9:30 a.m. to 1:30 p.m. and from 3:00 p.m. to 9:00 p.m.',
        quienes_somos : 'About Us',
        derechos_reservados : 'RADA S.R.L © 2020 All rights reserved',
        idiomas : 'Language',
        alquila_tu_auto_ahora: 'Rent your car now',

        //contacto
        telefonos : 'Telephone Contact',
        email_contact : 'Email Address',
        oficina_central : 'Central Office',
        enviar_mensajes : 'Send us a message',
        mensaje_nombre : 'Name',
        mensaje_telefono : 'Phone',
        mensaje_email : 'Email',
        mensaje_comentario : 'Write your query or comment here',
        enviar_mensaje : 'Send',

        //FLOTA
        flota_descripcion: 'Whether for business or pleasure, you can choose a vehicle from our fleet according to your needs. From compact cars for 5 passengers to family cars for 7 people, we are sure that you will find the car you need.',

        //BENEFICIOS
        beneficios_flota_amplia: 'Wide and modern fleet',
        beneficios_mejor_precio: 'The best market price',
        beneficios_soporte: '24/7 support',
        beneficios_reserva:'Reservations from your cell phone',
        beneficios_kilometraje:'Unlimited mileage',
        beneficios_conductores:'Up to 3 drivers at no additional cost',
        nuestras_sucursales: 'Our Branches',
        sucursales_subtitulo: 'Find us in the main destinations of Argentina'
    },
    'es': {
        alquilar : 'Alquilar',
        alquilar_ahora: 'Alquilar ahora',
        flota : 'Flota',
        menu_promociones :'promociones',
        menu_beneficios : 'Beneficios',
        contacto : 'Contacto',
        te_ayudamos : '¿te ayudamos?',
        amplia_gama : 'Amplia gama y disponibilidad de vehículos',
        reservar : 'Reservar',
        amplia_gama_body : 'Vas a encontrar siempre el vehículo que mejor se adapte a tus necesidades. Disponemos de una amplia y variada flota, con modelos de todos los tamaños y prestaciones.',
        mejor_experiencia : 'La mejor experiencia asegurada',
        personal_capacitado : 'Personal capacitado',
        personal_capacitado_body : 'Contamos con el mejor equipo de trabajo, totalmente capacitado para brindarte el mejor servicio.',
        servicio_excelencia : 'Servicio de excelencia',
        servicio_excelencia_body : 'Nos acomodamos a tus necesidades para brindarte la mejor experiencia en alquiler de vehículos con el mejor precio del mercado.',
        atencion_cliente : 'Atención al cliente',
        atencion_cliente_1 : 'Contactanos de Lunes a Domingo de 9.30 a 13.30 y de 15 a 21 hs.',
        quienes_somos : '¿Quines Somos?',
        derechos_reservados : 'RADA S.R.L © 2020 Reservados todos los derechos ',
        idiomas : 'Idioma',
        alquila_tu_auto_ahora: 'Alquilá tu Auto ahora',


        telefonos : 'Telefonos Contacto',
        email_contact : 'Correo Electronico',
        oficina_central : 'Oficina Central',
        enviar_mensajes : 'Envianos un mensaje',
        mensaje_nombre : 'Nombre',
        mensaje_telefono : 'Telefono',
        mensaje_email : 'Correo',
        mensaje_comentario : 'Escribí acá tu consulta o comentario',
        enviar_mensaje : 'Enviar',

        //FLOTA
        flota_descripcion: 'Ya sea por viaje de negocios o de placer, podés elegir un vehículo de nuestra flota según tu necesidad. Desde autos compactos para 5 pasajeros hasta familiares para 7 personas, estamos seguros de que vas a encontrar el auto que necesitás.',

        //BENEFICIOS
        beneficios_flota_amplia: 'Flota amplia y moderna',
        beneficios_mejor_precio: 'El mejor precio del mercado',
        beneficios_soporte: 'Soporte 24/7',
        beneficios_reserva:'Reservas desde tu celular',
        beneficios_kilometraje:'Kilometraje ilimitado',
        beneficios_conductores:'Hasta 3 conductores sin costo adicional',
        nuestras_sucursales: 'Nuestras Sucursales',
        sucursales_subtitulo: 'Encontranos en los principales destinos de Argentina'
    }
};

const i18n = new VueI18n({
    locale: 'es', // set locale
    fallbackLocale: 'es', // set fallback locale
    messages, // set locale messages
});

export default i18n;